function Svg() {

    this.render = function(icon) {
        var name = 'icon-' + icon.replace('icon-', '');
        var template = document.getElementById('svg-template-' + name);

        return template ? template.innerHTML.trim() : '';
    }
}
